{
  "movements": {
    "issueToRig": "Issue to rig",
    "returnFromRig": "Return from rig",
    "stocktake": "Stocktake"
  },
  "life": {
    "hoursOf": "{{used}} h of {{expected}} h",
    "metresOf": "{{used}} m of {{expected}} m"
  },
  "fields": {
    "serial": "Serial",
    "item": "Item",
    "items": "Items",
    "where": "Where",
    "life": "Life",
    "regrinds": "Regrinds",
    "retiredCount": "Retired",
    "averageLife": "Average life",
    "expected": "Expected",
    "expectedLife": "Expected life",
    "whyCameOff": "Why they came off",
    "partNo": "Part no.",
    "store": "Store",
    "lot": "Lot",
    "onHand": "On hand",
    "value": "Value",
    "useBy": "Use by",
    "minimum": "Minimum",
    "toOrder": "Order",
    "movement": "Movement",
    "fromTo": "From / to",
    "reference": "Reference",
    "tracked": "Tracked",
    "unitCost": "Unit cost",
    "unitCostIn": "Unit cost ({{symbol}})",
    "supplier": "Supplier",
    "when": "When",
    "from": "From",
    "into": "Into",
    "notes": "Notes",
    "reasonRequired": "Reason (required)",
    "inUse": "In use"
  },
  "states": {
    "retired": "Retired",
    "outOfDate": "Out of date",
    "soon": "Soon",
    "waitingForAdmin": "Waiting for an admin",
    "reversed": "Reversed",
    "notTracked": "Not tracked"
  },
  "tracking": {
    "bySerial": "By serial",
    "byLot": "By lot",
    "bulk": "Bulk"
  },
  "record": {
    "question": "Record it anyway?",
    "record": "Record",
    "anyway": "Record anyway"
  },
  "forms": {
    "editNamed": "Edit {{name}}"
  },
  "drillConsumables": {
    "notOnShift": "Not on this shift",
    "backFromRegrind": "Back from regrind",
    "includeRetired": "Include scrapped and lost",
    "stockPage": "Stock",
    "queued_one": "{{count}} change is saved on this device, waiting for a connection to reach the register.",
    "queued_other": "{{count}} changes are saved on this device, waiting for a connection to reach the register.",
    "tabFitted": "Fitted",
    "tabRegister": "Register",
    "tabLife": "Life",
    "noRigs": "No drill rigs on this shift, and nothing fitted on record.",
    "costsNote": "Quantities on hand and costs are on the stock page, for the store's admins."
  },
  "fitted": {
    "nothing": "Nothing fitted on record",
    "itemFittedAt": "{{item}} · fitted {{when}}",
    "change": "Change",
    "regrind": "Regrind",
    "takeOff": "Take off",
    "lifeBeforeFit": "{{life}} before this fit",
    "lifeBeforeFitRegrinds_one": "{{life}} before this fit · {{count}} regrind",
    "lifeBeforeFitRegrinds_other": "{{life}} before this fit · {{count}} regrinds",
    "panelTitle": "{{rig}} components",
    "fit": "Fit",
    "issueOilOrGrease": "Issue oil or grease",
    "return": "Return"
  },
  "fitForm": {
    "queued": "No connection, so fitting {{serial}} to {{rig}} is saved on this device. It goes on the register when the connection is back.",
    "done": "{{serial}} fitted to {{rig}}",
    "heading": "Fit to {{rig}}",
    "component": "Component",
    "nothingFits": "There is nothing in your stores that fits this rig."
  },
  "removeForm": {
    "queued": "No connection, so taking {{serial}} off {{rig}} is saved on this device. It goes on the register when the connection is back.",
    "done": "{{serial}} taken off {{rig}}",
    "heading": "Take {{serial}} off {{rig}}",
    "fittedOn": "{{item}}, fitted {{when}}.",
    "whereItGoes": "Where it goes",
    "regrindLocation": "Regrind location",
    "why": "Why",
    "metres": "Metres it drilled",
    "hours": "Percussion hours",
    "estimateNote": "Filled in from the rig's drilling since the fit, counting the shifts it went on and came off in for the part it was fitted. Correct it if you know better."
  },
  "returnForm": {
    "done": "{{serial}} is back in stock",
    "heading": "{{serial}} back from regrinding"
  },
  "movementForm": {
    "queued": "No connection, so the {{movement}} is saved on this device. It goes on the store's ledger when the connection is back; if the store cannot cover it then, it waits for an admin.",
    "recorded": "{{movement}} recorded",
    "direction": "Direction",
    "takeOut": "Take out of the store",
    "addTo": "Add to the store",
    "rigAndShift": "Rig and shift",
    "deliveryDocket": "Delivery docket",
    "quantity": "Quantity",
    "quantityIn": "Quantity ({{unit}})",
    "inTheStore": "{{quantity}} in the store",
    "serials": "Serials, one per unit",
    "removeLine": "Remove",
    "addItem": "Add an item",
    "lotNote": "Lot-tracked items leave the shelf earliest use-by first; an out-of-date lot is not used."
  },
  "stocktakeForm": {
    "agrees": "The count agrees with the ledger",
    "pendingApproval": "Counted. The difference waits for an admin to approve it.",
    "counted": "Counted.",
    "countedAt": "Counted at",
    "countSheet": "Count sheet",
    "noItems": "The ledger has no bulk items in this store to count.",
    "partAndLot": "{{part}} · Lot {{lot}}",
    "countedIn": "Counted ({{unit}})",
    "notCountedNote": "Anything not counted is recorded as none on the shelf.",
    "submit": "Submit count"
  },
  "pendingStocktakes": {
    "book": "Book",
    "cancel": "Cancel",
    "confirmCancel": "Cancel stocktake",
    "approveHeading": "Approve the {{store}} stocktake",
    "cancelHeading": "Cancel the {{store}} stocktake",
    "approveExplain": "Approving writes the store up or down to what was counted. The comment is kept with the stocktake and on the ledger.",
    "cancelExplain": "Cancelling leaves the ledger as it is. The comment is kept with the stocktake.",
    "posted": "Stocktake posted",
    "cancelled": "Stocktake cancelled"
  },
  "parked": {
    "intro": "These were recorded on a rig without a connection, and when they synced the store could not take them as they stood. They are not on the ledger until they are posted.",
    "explainPost": "It goes on the ledger at {{at}}, when it happened, and is costed then. Post it once the store's balance accounts for it, usually after a late delivery or a stocktake has been recorded."
  },
  "stock": {
    "reorderNote": "Eclipse lists what is below its minimum; the order itself is raised in the mine's purchasing system.",
    "reverseExplanation": "The ledger keeps the original and adds a reversing entry that puts every quantity back where it came from, at its original cost.",
    "reverse": "Reverse",
    "ledgerNote": "Movements are never edited or deleted; a mistake is reversed, which keeps both entries. A component's movements are corrected from the component register.",
    "stockValue": "Stock value",
    "yourZoneStores": "Your zone's stores",
    "belowMinimum": "Below minimum",
    "items_one": "item",
    "items_other": "items",
    "useBySoonOrPast": "Use-by soon or past",
    "lots": "lots",
    "outOfDate_one": "{{count}} out of date",
    "outOfDate_other": "{{count}} out of date",
    "tabStock": "Stock",
    "tabReorder": "Reorder",
    "tabLedger": "Ledger {{date}}",
    "tabCatalogue": "Catalogue",
    "tabStores": "Stores and levels"
  },
  "catalogue": {
    "add": "Add to the catalogue"
  },
  "stores": {
    "add": "Add a store",
    "levelSummary": "Min {{min}} · order {{order}}",
    "levels": "Levels"
  },
  "itemForm": {
    "partNumber": "Part number",
    "bitSize": "Bit size",
    "thread": "Thread",
    "unit": "Unit",
    "regrindCost": "Regrind cost",
    "expectedLifeMetres": "Expected life (m)",
    "expectedLifeHours": "Expected life (h)",
    "regrindEvery": "Regrind every (m)",
    "shelfLife": "Shelf life (months)",
    "erpPartNumber": "ERP part number",
    "lotTracked": "Lot-tracked"
  },
  "storeForm": {
    "kind": "Kind",
    "runByZone": "Run by zone",
    "visibilityNote": "Only the zone that runs a store sees it, its stock and its components; Lead Admins see every store."
  },
  "levelForm": {
    "heading": "{{item}} in {{store}}",
    "minimumIn": "Minimum ({{unit}})",
    "reorderIn": "Reorder quantity ({{unit}})",
    "note": "Below the minimum, the item goes on the reorder list. Set both to nothing to stop tracking it here."
  }
}
